/**
 * Persistence for post-signup onboarding (so no-organization page can skip stepper when done)
 */

const STORAGE_KEY = 'post_signup_onboarding_done';

export function getPostSignupOnboardingDone(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1' || import.meta.env.VITE_APP_NAME?.toLowerCase() !== 'tagadapay';
	} catch {
		return false;
	}
}

export function setPostSignupOnboardingDone(): void {
	try {
		localStorage.setItem(STORAGE_KEY, '1');
	} catch {
		// ignore
	}
}
